<script>
    import { user } from '../stores';
    import { db } from '../firebase';

	let searchedUsername = '';
</script>

<style>
	.add-friends {
		display: flex;
		flex-direction: row;
	}
</style>

<div class="add-friends">
	<input type="text" bind:value={searchedUsername} placeholder="Search for a username">
	<button on:click={() => {
		console.log(`adding ${searchedUsername}`);
		if (searchedUsername) {
			if (searchedUsername.toLowerCase() === $user.username_lowercase) {
				console.log('Can\'t add yourself, silly!');
				// TODO: show something
			}
			else if (searchedUsername.includes('#') && searchedUsername.indexOf('#') < searchedUsername.length - 1) {
				// Query on username
				// TODO: factor these queries out
				console.log(`Searching usernames for ${searchedUsername}`);
				db.collection('users').where('username_lowercase', '==', searchedUsername.toLowerCase())
					.get()
					.then(querySnapshot => {
						console.log(querySnapshot);
						querySnapshot.forEach(doc => {
                            // TODO: extract out (along with onAccept in requests) into "add friend"
							console.log(`Found: ${doc.id}`);
							console.log(doc.data());
							const friendRef = $user.ref.collection('friends').doc(doc.id);
							friendRef.get()
								.then(docRef => {
									if (docRef.exists) {
										console.log('User already in our friends list');
										// TODO: figure out if they've accepted or not, or just show "already added"
									} else {
										return friendRef.set({
                                            friendId: doc.id,
											realNameShared: false
										});
									}
								})
								.then(() => console.log('Friend request sent'))
								.catch(e => console.log(`Error sending friend request: ${e}`));
							// doc.ref.collection('friends').doc($user.uid).get()
                            // ^what was I trying to do here?  this line was just sitting there without a .then()
						});
					})
					.catch(e => console.log(`Error getting documents: ${e}`));
			} else {
				// Query on displayName
				console.log(`Searching display names for ${searchedUsername}`);
				db.collection('users').where('displayName_lowercase', '==', searchedUsername.toLowerCase())
					.get()
					.then(querySnapshot => {
						console.log(querySnapshot);
						querySnapshot.forEach(doc => {
							console.log(`Found: ${doc.id}`);
							console.log(doc.data());
						});
					})
					.catch(e => console.log(`Error getting documents: ${e}`));
			}
		}
	}}>Add friend</button>
</div>